import ApiService from '../apiservice'

export default class GraficoPessoasService extends ApiService {
  constructor() {
    super('/grafico-pessoas');
  }

  totalPessoas(empresa) {
    return this.get(`/total-pessoas/${empresa}`);
  }

  totalAtivas(empresa) {
    return this.get(`/total-ativas/${empresa}`);
  }

  totalInativas(empresa) {
    return this.get(`/total-inativas/${empresa}`);
  }

  totalComProcessos(empresa) {
    return this.get(`/total-com-processos/${empresa}`);
  }

  totalSemProcessos(empresa) {
    return this.get(`/total-sem-processos/${empresa}`);
  }

  totalCadastradosEsteMes(empresa) {
    return this.get(`/total-cadastrados-este-mes/${empresa}`);
  }

  faixaEtaria(empresa) {
    return this.get(`/faixa-etaria/${empresa}`);
  }

  profissao(empresa) {
    return this.get(`/profissao/${empresa}`);
  }

  aniversariantes(filtro) {
    return this.get(`/aniversariantes?empresa=${filtro.empresa}&mes=${filtro.mes}&idade=${filtro.idade}`);
  }
}